export const PARSING_TYPES = {
  URL: 'url',
  ITALICS: 'italics',
  NORMAL: 'normal',
}

export const italicsParser = (text, fromParser) => {
  const baseText = fromParser ? text.text : text;
  const italicsRegex = /_(.*?)_/g;
  const italicsArray = baseText.split(italicsRegex);

  if (italicsArray.length > 1) {
    return italicsArray.map((str, i) => (
      i % 2 === 0 ? { text: str } : { type: PARSING_TYPES.ITALICS, text: str }
    ));
  }

  return fromParser ? text : [{ text }];
}

export const urlParser = (text, fromParser) => {
  const baseText = fromParser ? text.text : text;
  const fullURLRegex = /\((.*?)\]/g;
  const urlContentRegex = /\)(.*?)\[/g;
  const urlArray = baseText?.split(fullURLRegex);

  if (urlArray?.length > 1) {
    return urlArray.map((str, i) => {
      if (i % 2 !== 0) {
        const textAndURL = str.split(urlContentRegex);
        return { type: PARSING_TYPES.URL, text: textAndURL[0], url: textAndURL[2] };
      }
      return { text: str };
    });
  }

  return fromParser ? text : [{ text }];
}

export const capitalize = text => {
  return `${text[0].toUpperCase()}${text.slice(1)}`;
}
